import {InputField} from "../input/InputField";
import {createRange} from "./create_range";

export const InputRange = createRange(InputField);
import {InputField} from "../input/InputField";
import {createRange} from "./create_range";

export const InputRange = createRange(InputField);
